import { useRef, useState } from 'react';
import Input from '../../UI/Input';
import classes from './MealItemForm.module.css';

const MealItemForm = (props) =>{
    const amountInputRef = useRef();
    const [amountIsValid, setAmountIsValid] = useState(true);
    const submitHandler = (event) => {
        event.preventDefault();
        const enteredAmount = amountInputRef.current.value;
        const enteredAmountNo = +enteredAmount;
        if(enteredAmount.trim().length === 0 || enteredAmount < 1 || enteredAmount > 5){
            setAmountIsValid(false);
            return;
        }
        props.onAddToCart(enteredAmountNo);
    };
    return (
        <form className={classes.form} onSubmit = {submitHandler}>
            <Input
                ref = {amountInputRef}
                label="Amount" input = {{
                id: 'amount',
                type: 'number',
                min: '1',
                max: '5',
                step: '1',
                defaultValue: '1'
            }}/>
            <button>+ Add</button>
            {!amountIsValid && <p>Please Enter a valid amount (1-5).</p>}
        </form>
    );
};
export default MealItemForm;